import { Box, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'
import React from 'react'
import { IconButtonMA } from '../../styles/styledComponents';
import { Close } from '@mui/icons-material';
import { ButtonCustom } from '../button';
import { font } from '../../styles/font';
import { theme } from '../../styles/theme';

export default function RevokeConfirmation({setOpenRevokeConfirm,openRevokeConfirm,handleRevokeEmployee,rowSelecter}) {
    // context

    function handleCloseRegisterDialog() {
        setOpenRevokeConfirm(false);
    }


   

    return (
        <Dialog onClose={handleCloseRegisterDialog} open={openRevokeConfirm}
            sx={{
                "& .MuiDialog-paper": {
                    minWidth: "30%",
                    //  minHeight: "60vh" 
                },
            }}
        >
            <DialogTitle>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Typography variant="h4" color={theme.col_3}>Remove Employee</Typography>

                    <Box display="flex" alignItems="center" gap={2}>
                       
                        <IconButtonMA size="small" onClick={handleCloseRegisterDialog}><Close /></IconButtonMA>
                    </Box>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ px: 1.5, }}>
                <Box py={0.8} px={1} display="flex" flexDirection="column" gap={2} alignItems='center'>

                    <Typography variant="h6" color={theme.col_2}>{rowSelecter?.length > 500 ? 'You can revoke only 500 employees at a time'  :  `Are you sure to revoke ${rowSelecter.length > 1 ? "these" : 'this'} employee`} </Typography>
                <Box py={0.8} px={1} display="flex" flexDirection="row" alignItems='center' gap={2}>

                    <ButtonCustom
                    onClick={handleRevokeEmployee}
                    fullWidth={false}
                    width='90px'
                    // disabled={loaderStateApi}
                    // loaderState={loaderStateApi}
                    borderRadius="42px"
                    size="large"
                    background={theme.col_3_alpha}
                    backgroundRipple={theme.col_3_alpha}
                    focusColor={theme.col_1}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    typography={
                      <Typography
                        fontFamily={font.family.fm_2}
                        textTransform={"capitalize"}
                        fontSize={font.size.fs_4}
                        fontWeight="bold"
                        color={theme.col_3}
                      >
                        Confirm 
                      </Typography>
                    }
                  />
                       <ButtonCustom
                    onClick={handleCloseRegisterDialog}
                    fullWidth={false}
                    width='90px'
                    // disabled={loaderStateApi}
                    // loaderState={loaderStateApi}
                    borderRadius="42px"
                    size="large"
                    background={theme.col_2_alpha}
                    backgroundRipple={theme.col_2_alpha}
                    focusColor={theme.col_1}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    typography={
                      <Typography
                        fontFamily={font.family.fm_2}
                        textTransform={"capitalize"}
                        fontSize={font.size.fs_4}
                        fontWeight="bold"
                        color={theme.col_2}
                      >
                        Cancel 
                      </Typography>
                    }
                  />
                </Box>
                </Box>
            </DialogContent>
        </Dialog>
    )
}
